module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0068.jpg?v=72296911";